import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import axios from './services/httpService';
import VueAxios from 'vue-axios';
import * as VueGoogleMaps from 'vue2-google-maps';


Vue.config.productionTip = false;
Vue.component('v-select', vSelect);
Vue.use(VueAxios, axios);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCO8jA-Iys0VMrUGCObc6dWDtCiDzPIkeg',
    libraries: 'places,drawing,visualization',
  },
  installComponents: true
});


new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
